import axios from 'axios';
import { constructUrl } from './dataApi';

const committedStatuses = new Set([
  'uploaded',
  'replaced',
  'already_committed',
  'replaced_old_cleanup_failed',
]);

export const createUploadOperationId = () => {
  const randomId =
    typeof window !== 'undefined' && window.crypto && typeof window.crypto.randomUUID === 'function'
      ? window.crypto.randomUUID()
      : Math.random().toString(36).slice(2);

  return `portal-upload-${Date.now()}-${randomId}`;
};

export const getReplacementStatus = (result = {}) => {
  return result.replacementStatus || result.data?.replacementStatus || null;
};

export const isCommittedUpload = (result = {}) => {
  return committedStatuses.has(getReplacementStatus(result));
};

export const shouldReconcileUploadError = (error) => {
  return !error?.response && !axios.isCancel(error) && error?.code !== 'ERR_CANCELED';
};

export const reconcileCandidateFileUpload = async ({
  clientOperationId,
  headers,
  isProfilePhoto,
  pk_Candidate,
  pk_Department,
  pk_DocumentType,
}) => {
  const params = {
    clientOperationId,
    isProfilePhoto: Boolean(isProfilePhoto),
    pk_Candidate,
    pk_Department,
  };

  if (!isProfilePhoto) {
    params.pk_DocumentType = pk_DocumentType;
  }

  const response = await axios.get(constructUrl('files/candidate/upload-operation'), {
    headers,
    params,
  });

  return response.data;
};

export const getUploadOutcomeMessage = ({ isProfilePhoto, replacementStatus }) => {
  const fileLabel = isProfilePhoto ? 'photo' : 'document';

  if (replacementStatus === 'original_retained') {
    return `The replacement ${fileLabel} failed. The existing ${fileLabel} is still available.`;
  }

  if (replacementStatus === 'first_upload_failed') {
    return `The ${fileLabel} could not be uploaded.`;
  }

  if (replacementStatus === 'unknown_reconciliation_required') {
    return `The ${fileLabel} upload status could not be confirmed. Refresh status before retrying.`;
  }

  return `The ${fileLabel} upload could not be completed.`;
};

export const createFailedUploadOutcome = ({ clientOperationId, file, isProfilePhoto, replacementStatus }) => {
  return {
    canRetry: replacementStatus !== 'unknown_reconciliation_required',
    clientOperationId,
    file,
    message: getUploadOutcomeMessage({ isProfilePhoto, replacementStatus }),
  };
};
